import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { FormControl, FormLabel, FormGroup, Input } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import cx from "classnames";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomInput.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import CustomButtons from "components/CustomButtons/Button";
import axios from "axios";
const style = (theme) => ({
  container: {
    fontWeight: 400,
    maxWidth: 1800,
  },
  center: {
    textAlign: "center",
    margin: 20,
    marginTop: 40,
  },
  checkIcon: {
    color: "#A5DC86",
    border: "solid 4px",
    borderRadius: 22,
    padding: 2,
    fontSize: 44,
    borderColor: "aquamarine",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  titleContent: {
    paddingTop: 5,
    paddingLeft: 10,
    position: "absolute",
  },
  loginModalTitle: {
    fontWeight: 600,
    textAlign: "left",
    color: "#1AA2DF",
  },
  subTitle: {
    fontWeight: 400,
    fontSize: "16px",
  },
  floatLeft: {
    float: "left",
  },
  floatRight: {
    float: "right",
  },
  floatNone: {
    float: "none",
  },
  alignLeft: {
    textAlign: "left",
  },
  alignRight: {
    textAlign: "right",
  },
  detailsHeader: {
    textAlign: "left",
    marginBottom: 20,
    fontSize: 18,
  },
  detailsRow: {
    marginTop: 10,
    color: "black",
    paddingRight: 15,
  },
  selectLabel: {
    fontSize: 14,
    textTransform: "none",
    color: "#AAAAAA !important",
    //top: 7
  },
  select: {
    paddingBottom: 10,
    fontSize: 14,
  },
  selectFormControl: {
    [theme.breakpoints.up("lg")]: {
      marginTop: -15,
    },
  },
  countryFormControl: {
    marginTop: 5,
  },
  modalCloseButton: {
    float: "right",
  },
  loginMaxWidth: {
    maxWidth: 650,
  },
  emptyIcon: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  paper: { width: "400px" },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class LoanReject extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      notes: "",
      notesState: "",
      notesErrorMsg: [],
      reason: "",
      showModal: true,
      documentLink: "google.com",
    };
  }
  handleClickOpen() {
    this.setState({ showModal: true });
  }
  handleClose() {
    this.props.closeModal();
  }
  handleRejectSubmit = async () => {
    const data = {
      loanApplicationId: this.props.trade,
      reason: this.state.reason,
      text: this.state.notes,
    };
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    let response = await axios.post(
      "loan-service/v1/agent/loan/application/reject",
      data,
      header
    );
    if (response.data.error_code) {
      console.error(response.data.user_description);
    } else {
      this.props.closeModal();
    }
  };
  change = (event, stateName, rules) => {
    let value = event.target.value;

    this.setState({ [stateName]: value });
  };
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  static getDerivedStateFromProps(props, state) {
    if (props.showModal !== state.showModal) {
      return {
        showModal: props.showModal,
      };
    }
    return null;
  }
  handleReasonChange = (event) => {
    this.setState({
      reason: event.target.value,
    });
  };
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    const { classes, trade } = this.props;
    const { showModal } = this.state;
    return trade ? (
      <div className={classes.container}>
        <Dialog
          maxWidth="sm"
          open={showModal}
          
          disableEscapeKeyDown
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose()}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
          classes={{ paper: classes.paper }}
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={cx(classes.modalHeader)}
          >
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={() => this.handleClose()}
            >
              <CloseIcon />
            </IconButton>
            <h3 className={cx(classes.modalTitle, classes.loginModalTitle)}>
              <span className={(classes.titleContent, classes.floatLeft)}>
                Loan Reject Details
              </span>
            </h3>
          </DialogTitle>
          <DialogContent
            id="classic-modal-slide-description"
            className={cx(classes.modalBody, classes.loginMaxWidth)}
          >
            <GridContainer justifyContent="center">
              <GridItem xs={12} sm={10} md={12} lg={12}>
                <GridContainer justifyContent="flex-start" className={classes.content}>
                  <GridItem
                    xs={12}
                    sm={11}
                    md={11}
                    lg={11}
                    className={classes.alignRight}
                  >
                    <FormControl fullWidth>
                      <InputLabel className={classes.labelStyle}>
                        Reasons*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={this.state.reason}
                        onChange={(event) => this.handleReasonChange(event)}
                      >
                        <MenuItem value={"Lower LTV"}>Lower LTV</MenuItem>
                        <MenuItem value={"High ROI"}>High ROI</MenuItem>
                        <MenuItem value={"Already taken from Other"}>
                          Already taken from Other
                        </MenuItem>
                        <MenuItem value={"Not Interested"}>
                          Not Interested
                        </MenuItem>
                        <MenuItem value={"Other"}>Other</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={11}
                    md={11}
                    lg={11}
                    className={classes.alignRight}
                  >
                    <CustomInput
                      success={this.state.notesState === "success"}
                      error={this.state.notesState === "error"}
                      helpText={
                        this.state.notesState === "error" &&
                        this.state.notesErrorMsg[0]
                      }
                      labelText="Notes*"
                      id="lp_BranchName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.notes || "",
                        onChange: (event) => {
                          this.change(event, "notes", [{ type: "required" }]);
                        },
                        type: "string",
                      }}
                    />
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={11}
                    md={11}
                    lg={11}
                    style={{
                      marginTop: 10,
                      marginBottom: 20,
                      textAlign: "center",
                    }}
                  >
                    <CustomButtons
                      size="sm"
                      color="info"
                      className="bg-gradient-theme-left border-0"
                      onClick={() => this.handleRejectSubmit()}
                    >
                      Submit
                    </CustomButtons>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </DialogContent>
        </Dialog>
      </div>
    ) : (
      <></>
    );
  }
}

LoanReject.propTypes = {
  classes: PropTypes.object,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  trade: PropTypes.object,
};

export default withStyles(style)(LoanReject);
